import { render, staticRenderFns } from "./_workFloGeneralCustomer.vue?vue&type=template&id=b5b4bb8c&scoped=true&"
import script from "./_workFloGeneralCustomer.vue?vue&type=script&lang=js&"
export * from "./_workFloGeneralCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b4bb8c",
  null
  
)

export default component.exports